import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86ef266c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "homework-list-cont" }
const _hoisted_2 = { class: "homework-list" }

import ExpansionPanel from '@/common/components/snedson-material-components/expansion-panel/expansion-panel.vue';
import $api from '@/http/api';
import { onMounted, reactive } from 'vue';
import { GetHomeworkListResponseModel } from './HomeworkSubpage.types';
import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import router from '@/router';
import { getTeacherClassPageHomeworkSubpage } from './apiMethods';
import { getBaseUrl } from '@/http/api/';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeworkSubpage',
  setup(__props) {

const state = reactive<{ data: GetHomeworkListResponseModel }>({
    data: { homeworks: {} },
});

onMounted(() => {
    const classId = router.currentRoute.value.params.classId;
    getTeacherClassPageHomeworkSubpage(classId).then((res) => {
        state.data = res.data;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(state.data.homeworks), (homework) => {
      return (_openBlock(), _createBlock(ExpansionPanel, {
        props: {
                title: `На ${new Date(homework[0]).toLocaleDateString()}`,
            },
        key: homework[0]
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homework[1], (homeworkElement, index) => {
              return (_openBlock(), _createBlock(UniversalCard, {
                key: index,
                class: _normalizeClass(homeworkElement.colorSchemeName),
                props: {
                        type: 'filled',
                        content: homeworkElement.taskText,
                        dataTags: [
                            {
                                title: homeworkElement.subjectName,
                                color: 'var(--snotra--sys--surface)',
                                iconCompleteUrl: `${_unref(getBaseUrl)()}${
                                    homeworkElement.iconURL
                                }`,
                            },
                            {
                                title: homeworkElement.groupName
                                    ? homeworkElement.groupName
                                    : 'Весь класс',
                                color: 'var(--snotra--sys--surface)',
                                iconLocal: 'student.png',
                            },
                            {
                                title: `Было задано: ${new Date(
                                    homeworkElement.appendDate
                                ).toLocaleDateString()}`,
                                color: 'var(--snotra--sys--surface)',
                                iconLocal: 'calendar.png',
                            },
                            {
                                title: `Задание добавил: ${homeworkElement.authorName}`,
                                color: 'var(--snotra--sys--surface)',
                                iconLocal: 'student.png',
                            },
                        ],
                    }
              }, null, 8, ["class", "props"]))
            }), 128))
          ])
        ]),
        _: 2
      }, 1032, ["props"]))
    }), 128))
  ]))
}
}

})